import '../pages/responsibility/style.less'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { ResponsibilityDetail } from '../pages/responsibility'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <ResponsibilityDetail />
    </React.StrictMode>
  )
}
